import React, {Fragment} from "react";
import Translate from "../Translate";
import {Link} from "react-router-dom";

export default function NsButtonNavigazione({
                                                nome,
                                                label,
                                                icona,
                                                href,
                                                disabled,
                                                type = "button",
                                                onClick = () => {
                                                },
                                            }) {

    return (
        <Fragment>
            {
                href ?
                    <Link to={href} className={"btn btn-card"} data-toggle="tooltip" title={label}>
                        {
                            icona &&
                            <i className={icona}/>
                        }
                        <span className={'ns-display-mobile'}><Translate>{label}</Translate></span>
                    </Link>
                    :
                    <button type={type} id={nome} name={nome} disabled={disabled}
                            className="btn btn-card"
                            onClick={onClick}
                            data-toggle="tooltip" title={label}
                    >
                        {
                            icona &&
                            <i className={icona}/>
                        }
                        <span className={'ns-display-mobile'}> <Translate>{label}</Translate></span>
                    </button>
            }
        </Fragment>
    )
}